document.querySelectorAll('a[data-obcl]').forEach((link) => {
    link.addEventListener('click', (event) => {

        event.preventDefault()
        event.stopPropagation()

        const target = atob(link.getAttribute('data-obcl'))

        if(link.getAttribute('target') === '_blank') {
            window.open(target, '_blank')
        } else {
            document.location = target
        }
    })
})
